module.exports = __webpack_public_path__ + "img/landing-page-lightbulb.25f00790.svg";